import React from 'react'
import { Helmet } from 'react-helmet-async'

import StepContent from '@/components/flows/WalkthroughFlow/components/StepContent'
import StepControls from '@/components/flows/WalkthroughFlow/components/StepControls'
import StepList from '@/components/flows/WalkthroughFlow/components/StepList'
import { useWalkthroughSteps } from '@/components/flows/WalkthroughFlow/hooks/useWalkthroughSteps'
import { Container } from '@/components/ui/container'
import usePosthogCapture from '@/hooks/usePosthogCapture/usePosthogCapture'

export interface WalkthroughFlowProps {
  title?: React.ReactNode
  variant: 'page' | 'component'
  completeButtonText: string
  onComplete: () => void
  isCompleting?: boolean
}

const WalkthroughFlow: React.FC<WalkthroughFlowProps> = ({
  title,
  variant,
  completeButtonText,
  onComplete,
  isCompleting = false,
}) => {
  const { currentStep } = useWalkthroughSteps()

  usePosthogCapture({
    dependencyListener: {
      dataProvider: () => ({
        appArea: 'walkthrough',
        action: 'step-visited',
        stepName: currentStep.key,
      }),
      dependencyList: [currentStep],
    },
  })

  const isPageVariant = variant === 'page'

  return (
    <>
      <Helmet title={currentStep.label} />

      <StepControls
        variant={variant}
        title={title}
        completeButtonText={completeButtonText}
        onComplete={onComplete}
        isCompleting={isCompleting}
      />

      <Container className={isPageVariant ? 'py-8' : 'py-sm-6 py-12'}>
        <div className="grid grid-cols-12 gap-x-4 gap-y-6">
          <div className="col-span-full lg:col-span-3">
            <StepList />
          </div>

          <div className="col-span-full lg:col-span-9">
            <StepContent />
          </div>
        </div>
      </Container>
    </>
  )
}

export default WalkthroughFlow
